import { useState } from 'react'
import { extractProfileInfo } from 'components/ExternalIntegrationSelect/utils'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import Styles from './FacebookStoryPreview.module.scss'
import { VolumeOn, Pause, MoreDots } from 'blaze-ui/icons'
import { FacebookIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Button } from 'blaze-ui/Button'
import { Edit1 } from 'blaze-ui/icons'

interface HeaderProps {
  integration?: FacebookIntegration
  onEdit?: () => void
}

export const Header = ({ integration, onEdit }: HeaderProps) => {
  const { name, avatar } = integration ? extractProfileInfo(integration) : { name: '', avatar: Silhouette }
  const [imageFailed, setImageFailed] = useState(false)

  return (
    <div className={Styles.headerContainer}>
      <div className={Styles.loadingBar}>
        <div className={Styles.progress}></div>
      </div>
      <div className={Styles.header}>
        {imageFailed ? (
          <img className={Styles.avatar} src={Silhouette} alt="Avatar" />
        ) : (
          <img
            className={Styles.avatar}
            src={avatar || Silhouette}
            alt={name || 'Avatar'}
            onError={() => setImageFailed(true)}
          />
        )}
        <span className={Styles.username}>{name}</span>
        <span className={Styles.time}>1h</span>
        {onEdit && (
          <Button variant="tertiary" onPress={onEdit} frontIcon={Edit1}>
            Edit
          </Button>
        )}
        <div className={Styles.headerActions}>
          <VolumeOn />
          <Pause />
          <MoreDots />
        </div>
      </div>
    </div>
  )
}
